export default "__VITE_ASSET__80eff56b__"